import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = {
  key: 0,
  class: "h-5 w-5 text-yellow-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "h-5 w-5 text-red-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "h-5 w-5 text-green-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "ml-3" }
const _hoisted_13 = { class: "ml-auto pl-3" }
const _hoisted_14 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: 'success' }
  },
  emits: ['dismiss'],
  setup(__props: any, { emit: emits }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border-l-4 p-4", [
      __props.type === 'warning' ? 'bg-yellow-50 border-yellow-400' : '',
      __props.type === 'error' ? 'bg-red-50 border-red-400' : '',
      __props.type === 'success' ? 'bg-green-50 border-green-400' : '',
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.type === 'warning')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        (__props.type === 'error')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        (__props.type === 'success')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", {
          class: _normalizeClass(["text-sm", [
            __props.type === 'warning' ? 'text-yellow-700' : '',
            __props.type === 'error' ? 'text-red-700' : '',
            __props.type === 'success' ? 'text-green-700' : '',
          ]])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2", [
              __props.type === 'warning'
                ? 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 focus:ring-offset-yellow-50 focus:ring-yellow-600'
                : '',
              __props.type === 'error'
                ? 'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600'
                : '',
              __props.type === 'success'
                ? 'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600'
                : '',
            ]]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('dismiss')))
          }, _hoisted_17, 2)
        ])
      ])
    ])
  ], 2))
}
}

})